import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isStreakAuditApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getStreakAuditPayload = (res) => res?.data ?? null;

const SESSION_USER_ID_KEY = 'streakAuditLastUserId';

export const getLastSearchedUserId = () => {
  const stored = sessionStorage.getItem(SESSION_USER_ID_KEY);
  return stored ? Number(stored) : null;
};

export const setLastSearchedUserId = (userId) => {
  if (userId) {
    sessionStorage.setItem(SESSION_USER_ID_KEY, String(userId));
  }
};

/** GET /admin/streaks/users/:userId/debug */
export const fetchStreakAuditReport = async (filters) => {
  const { userId, fromDate, toDate, days } = filters;
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  if (days != null && !fromDate) params.set('days', String(days));

  const qs = params.toString();
  const path = `/admin/streaks/users/${userId}/debug${qs ? `?${qs}` : ''}`;
  return authFetch(path, { method: 'GET' });
};
